<div class="adWritter" *ngIf="view == 0">
  <div class="">
    <div class="">
      <h1 class="">Let one of our professionals write Your ad for You</h1>
    </div>
    <div class="">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
<div class="adWritter" *ngIf="view > 0">
  <div class="" *ngIf="view == 1 || view == 2">
    <h1 class="adWritter__title">Let one of our professionals write your ad for You</h1>
    <div class="adWritter__text first">
      <img src="/images/person1.jpg" alt="Help" class="m-2">
      <p>We all know that writing about ourselves could be a challenging task as we are not sure what others would find appealing, and what would be considered as a turnoff. We are here to make things easier for you to ensure that your Wickedlist experience is not only pleasant but unforgettable.</p>
    </div>
    <div class="adWritter__text second">
      <p>Fill out the following form to provide basic information about yourself and what you are looking for. (Fill out ONLY as much you want to share with others) Once you send this to us, one of our team members will write an ad for you and send it back through the email you provide. Please note that we won’t write casual dating ads so make sure that you want us to write ONLY the long-term relationship ad.</p>
      <img src="/images/person2_mobile.jpg" alt="Help" class="m-2">
    </div>
  </div>
  <div *ngIf="view == 1" class="animated fadeIn">
    <div>
      <div class="">
        <div class=""><strong>Your basic info:</strong></div>
      </div>
      <form class="adWritter__form" [formGroup]="dataForm" (ngSubmit)="onSubmit()">
        <div class="formFields adWritter__formFields">
          
          <mat-form-field class="formFields__name">
            <mat-label>Name / nickname</mat-label>
            <input type="text" formControlName="name" matInput>
          </mat-form-field>
        
          <mat-form-field class="formFields__gender">
            <mat-label>Gender</mat-label>
            <mat-select formControlName="gender">
              <mat-option *ngFor="let g of gender" [value]="g">
                {{g}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        
          <mat-form-field class="formFields__race">
            <mat-label>Race</mat-label>
            <mat-select formControlName="race">
              <mat-option *ngFor="let r of race" [value]="r">{{r}}</mat-option>
            </mat-select>
          </mat-form-field>
        
          <mat-form-field class="formFields__lookingFor">
            <mat-label>I'm looking for</mat-label>
            <mat-select formControlName="lookingFor">
              <mat-option *ngFor="let g of gender" [value]="g">
                {{g}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        
          <mat-form-field class="formFields__age">
            <mat-label>Age</mat-label>
            <input formControlName="age" matInput>
          </mat-form-field>
        
          <mat-form-field class="formFields__height">
            <mat-label>Height</mat-label>
            <input formControlName="height" matInput>
          </mat-form-field>
        
          <mat-form-field class="formFields__weight">
            <mat-label>Weight</mat-label>
            <input formControlName="weight" matInput>
          </mat-form-field>
        
          <mat-form-field class="formFields__bodyType">
            <mat-label>Body Type</mat-label>
            <mat-select formControlName="bodyType">
              <mat-option [value]="'Average'">Average</mat-option>
              <mat-option [value]="'Athletic / fit'">Athletic / fit</mat-option>
              <mat-option [value]="'Few extra pounds / chubby'">Few extra pounds / chubby</mat-option>
              <mat-option [value]="'Muscular'">Muscular</mat-option>
            </mat-select>
          </mat-form-field>
        
        
          <mat-form-field class="formFields__idealMatch">
            <mat-label>My ideal match would be</mat-label>
            <textarea formControlName="idealMatch" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__lookingForRelationship">
            <mat-label>What are you looking for in a relationship?</mat-label>
            <textarea formControlName="lookingForRelationship" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__thingsInFreeTime">
            <mat-label>What’s your favorite thing to do during free time?</mat-label>
            <textarea formControlName="thingsInFreeTime" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__aspectsOfLife">
            <mat-label>Important things/aspects of life for you</mat-label>
            <textarea formControlName="aspectsOfLife" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__dontLike">
            <mat-label>Things you don’t like</mat-label>
            <textarea formControlName="dontLike" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__passions">
            <mat-label>Your passion / interest</mat-label>
            <textarea formControlName="passions" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__occupation">
            <mat-label>Your occupation</mat-label>
            <textarea formControlName="occupation" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__characteristics">
            <mat-label>What’s your 4 characteristics that are dominating in your personality?</mat-label>
            <textarea formControlName="characteristics" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__goalsAndDreams">
            <mat-label>Your goals and dreams</mat-label>
            <textarea formControlName="goalsAndDreams" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__thankfullFor">
            <mat-label>I’m thankful the most for</mat-label>
            <textarea formControlName="thankfullFor" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__kids">
            <mat-label>Do you have kids / want kids?</mat-label>
            <textarea formControlName="kids" matInput s="6"></textarea>
          </mat-form-field>
        
          <mat-form-field class="formFields__education">
            <mat-label>Your education</mat-label>
            <textarea formControlName="education" matInput s="6"></textarea>
          </mat-form-field>

          <div class="radioGroupList formFields__radioGroupList">
            <div class="radioGroupList__header">
              <strong>Your lifestyle:</strong>
            </div>

            <div class="radioGroupList__item">
              <label>Do you work out?</label>

              <mat-radio-group formControlName="workout">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="radioGroupList__item">
              <label>Do you travel?</label>

              <mat-radio-group formControlName="travel">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="radioGroupList__item">
              <label>Do you eat healthy food?</label>

              <mat-radio-group formControlName="healthyFood">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="radioGroupList__item">
              <label>Do you smoke?</label>
      
              <mat-radio-group formControlName="smoke">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="radioGroupList__item">
              <label>Do you drink alcohol?</label>
    
              <mat-radio-group formControlName="alcohol">
                <mat-radio-button value="Yes">Yes</mat-radio-button>
                <mat-radio-button value="No" class="ml-3">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

    
          <mat-form-field class="formFields__yourEmail">
            <mat-label><strong>Your email</strong> (we will send your ad to this email)</mat-label>
            <input type="text" formControlName="email" matInput required>
          </mat-form-field>

          <mat-checkbox class="formFields__termsAndConditions" required="true" formControlName="termsAndConditions">
            By checking this box you agree upon our terms that we will write the ad for you using up to 200 words. You won’t have any revision after receiving your written ad. We might not use all the provided info in the form. You have no guarantee that this ad will help you find a partner. Also, we do not offer any refund if for some reason you are not satisfied. It might take up to 24-48 hours to send your ad- depending upon traffic
          </mat-checkbox>
  
          <div class="col-4 pl-0">
            <premium-ad-token-payment #addTokenPayment [paymentFormType]="1" (onTokenAdded)="onTokenAdded($event)"></premium-ad-token-payment>
          </div>
        
          <button class="create-button w-100 p-2" style="width: 100%;" color="primary" mat-flat-button type="submit" [disabled]="blockSubmit" >
            <mat-spinner style="margin:auto;" color="primary" diameter="30" *ngIf="loading"></mat-spinner><span *ngIf="!loading">Pay $9.99 & Submit</span>
          </button>
        </div>
      </form>
    </div>

  </div>
  <div *ngIf="view == 3">
    <div class="">
      <div class="">
        <h1 class="mt-4">Thank You for posting data!</h1>
      </div>
      <div class=" mb-3">
        We will contact You with your new brilliant advertisement!
      </div>
      <div class="">
        <a mat-flat-button color="accent" routerLink="/">Go to main page</a>
      </div>
    </div>
  </div>


</div>
